// extracted by mini-css-extract-plugin
export default {"highlighted":"nC5Tz"};